'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import text from 'I18n/utils/unescapedText';
import UITextInput from 'UIComponents/input/UITextInput';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import withConnectedMenuLabel from 'simple-menus-lib/components/menu/decorators/withConnectedMenuLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class MenuItemLabel extends PureComponent {
  renderCollapseButton() {
    if (this.props.hasChildren) {
      return /*#__PURE__*/_jsx(UIIconButton, {
        use: "transparent",
        onClick: this.props.toggleCollapse,
        size: "small",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: this.props.isCollapsed ? 'right' : 'down'
        })
      });
    }
    return null;
  }
  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "simple-menus-menu-item-label",
      draggable: true,
      onDragStart: e => {
        // When trying to highlight text prevent the
        // entire component from dragging
        e.preventDefault();
        e.stopPropagation();
      },
      children: [this.renderCollapseButton(), /*#__PURE__*/_jsx(UITextInput, {
        className: "label-input",
        "data-test-id": "menu-label",
        defaultValue: this.props.label,
        onChange: this.props.onLabelChange,
        placeholder: text('simpleMenusLib.components.menuItemLabel.placeholder'),
        disabled: this.props.readOnly
      })]
    });
  }
}
MenuItemLabel.defaultProps = {
  label: ''
};
MenuItemLabel.propTypes = {
  toggleCollapse: PropTypes.func.isRequired,
  hasChildren: PropTypes.bool.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  /* Connect */
  label: PropTypes.string.isRequired,
  onLabelChange: PropTypes.func.isRequired
};
export default withConnectedMenuLabel()(MenuItemLabel);